import formatPrice from './formatPrice';

export default function(value: number | string | bigint | null): string {
    const formattedPrice = formatPrice(value);

    if (formattedPrice === '-') {
        return formattedPrice;
    }

    const [intPart, fracPart] = formattedPrice.split('.');
    const sign = intPart.startsWith('-') ? '-' : '';
    const absIntPart = sign ? intPart.slice(1) : intPart;
    const formattedIntPart = absIntPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return `${sign}${formattedIntPart}.${fracPart}`;
}
